/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OnInit, Component, Input } from '@angular/core';
import { I18nService } from '@dm/core';

import { type LanguageItem } from './header-language';

@Component({
    selector: 'app-header-language',
    templateUrl: './header-language.component.html',
    styleUrls: ['./header-language.component.scss'],
})
export class HeaderLanguageComponent implements OnInit {
    @Input() isSmallSize: boolean;
    @Input() isSimpleMode: boolean;

    tooltipVisible = false;
    languageMap = new Map([
        ['zh', '中文'],
        ['en', 'English'],
        ['ja', '日本語'],
    ]);
    languageAbbr = ['zh', 'en', 'ja'];
    currentLanguage = this.languageMap.get(this.i18nService.language);

    languageList: LanguageItem[] = [];
    constructor(
        public i18nService: I18nService,
    ) { }

    ngOnInit(): void {
        this.setLanguageList();
    }

    setLanguageList(): void {
        this.languageList = this.languageAbbr.map((value: string) => ({
            label: this.languageMap.get(value) as string,
            hide: this.currentLanguage === this.languageMap.get(value),
            command: (): void => {
                this.i18nService.changeLanguage(value);
                this.tooltipVisible = false;
                this.languageList.forEach((item: LanguageItem) => {
                    item.hide = item.label === value;
                });
            },
        }));
    }
}
